requirejs.config({
   // By default, load any module IDs from js/eco
   baseUrl: '/js/eco/',

   // Except for the following paths
   paths: {
      jquery: '/js/eco/third-party/jquery-1.11.1',
      jquerycookie: '/js/eco/third-party/jquery.cookie',
      jquerybbq: '/js/eco/third-party/jquery.ba-bbq',
      jquerybrowser: '/js/eco/third-party/jquery.browser',
      jqueryenter: '/js/eco/third-party/jquery.enter',
      jqueryui: '/js/eco/third-party/jquery.ui.core',
      jqueryeffects: '/js/eco/third-party/jquery.ui.effects',
      jquerycolor: '/js/eco/third-party/jquery.color',
      jqueryplaceholder: '/js/eco/jqueryPlugins/jquery.placeholder',
      c21minmaxdropdown: '/js/eco/jqueryPlugins/jquery.c21minmaxdropdown',
      c21textdropdown: '/js/eco/jqueryPlugins/jquery.c21textdropdown',
      c21dropdown: '/js/eco/jqueryPlugins/jquery.c21dropdown',
      c21list: '/js/eco/jqueryPlugins/jquery.c21list',
      jqueryuniform: '/js/eco/third-party/jquery.uniform',
      jqueryinfinitescroll: '/js/eco/third-party/jquery.infinitescroll',
      bootstrap: '/js/eco/third-party/bootstrap',
      raphael: '/js/eco/third-party/raphael',
      Modernizr: '/js/eco/third-party/Modernizr',
      photoswipe: '/js/eco/third-party/photoswipe/photoswipe',
      photoswipeui: '/js/eco/third-party/photoswipe/photoswipe-ui-default',
      Mustache: '/js/eco/third-party/mustache.min',
      modalWindow: '/js/eco/c21/modalWindow',
      mortgageCalc: '/js/eco/c21/mortgage',
      binginfobox: '/js/eco/third-party/ve7.infobox',
      listhub: '//tracking.listhub.net/scripts/la.js',
      usagetrack: '/js/eco/c21/usage-track',
      ctctrack: '/js/eco/c21/ctc-track',
      listTrac: '/js/eco/c21/listTrac'
   },

   shim: {
      'c21/track': {
         exports: 'Track'
      },

      jquery: {
         exports: '$'
      },

      binginfobox: ['bing'],

      bootstrap: {
         deps: ['jquery']
      },

      /*
      bing: {
         exports: 'Microsoft.Maps'
      },
      */

      raphael: {
         exports: 'Raphael'
      },

      jquerycolor: ['jquery'],

      jquerybbq: {
         deps: ['jquery', 'jquerybrowser'],
         exports: 'jQuery.param.fragment'
      },

      // Note: Please enter the export value
      // so requirejs can verify the library has loaded
      jquerycookie: {
         deps: ['jquery'],
         exports: 'jQuery.fn.cookie'
      },

      jqueryplaceholder:['jquery'],

      c21list: ['jquery'],
      c21dropdown: ['jquery'],

      c21textdropdown: {
         deps: ['jquery', 'c21list', 'c21dropdown'],
         exports: 'jQuery.fn.c21textdropdown'
      },

      c21minmaxdropdown: {
         deps: ['jquery', 'c21list', 'c21dropdown'],
         exports: 'jQuery.fn.c21minmaxdropdown'
      },

      jqueryui: ['jquery'],

      jqueryeffects: ['jquery', 'jqueryui'],

      jqueryenter: {
         deps: ['jquery'],
         exports: 'jQuery.fn.enter'
      },

      jquerybrowser: {
         deps: ['jquery'],
         exports: 'jQuery.browser'
      },

      jqueryuniform: ['jquery', 'jquerybrowser'],

      jqueryinfinitescroll: ['jquery'],

      Modernizr: {
         deps: ['jquery'],
         exports: 'Modernizr'
      },

      photoswipe: {
         deps: ['Modernizr']
      },

      modalWindow: {
         deps: ['jquery', 'Mustache']
      },

      usagetrack: {
         deps: ['jquery'],
         exports: 'usagetrack'
      },

      ctctrack: {
         deps: ['jquery', 'usagetrack'],
         exports: 'ctctrack'
      },

      listTrac: {
         deps: ['jquery']
      },
   }
});
